import { contract } from "./contract";
import { AppSettings } from "Store/AppSettingStore";

type urlOptions = "ospServiceApiUrl" | "identityServiceApiUrl" | "elipServiceApiUrl";
type urlConfig = Record<keyof typeof contract, urlOptions>;

const baseUrlConfig: Partial<urlConfig> = {
    accessApi: "identityServiceApiUrl",
    accessPersonnelGroupApi: "identityServiceApiUrl",
    identityAccessApi: "identityServiceApiUrl",
    directELIPApi: "elipServiceApiUrl"
};

function isContractKey(key: string): key is keyof urlConfig {
    return key in baseUrlConfig;
}

function getBaseUrlKey(path: readonly string[]): urlOptions {
    if (path.length < 1) {
        return "ospServiceApiUrl";
    }
    const key = path[0];
    if (key !== undefined && isContractKey(key)) {
        return baseUrlConfig[key] ?? "ospServiceApiUrl";
    }
    return "ospServiceApiUrl";
}

export function getBaseUrl(path: readonly string[], settings: AppSettings): string {
    const baseUrlKey = getBaseUrlKey(path);
    if (
        baseUrlKey === "identityServiceApiUrl" &&
        settings.enableUMSInnerRing === "true" &&
        settings.innerRingIdentityServiceApiUrl &&
        localStorage.getItem("ums_tenant_mode") === "InnerRing"
    ) {
        return settings.innerRingIdentityServiceApiUrl;
    }
    return settings[baseUrlKey] ?? "";
}
